import React, { useContext, useEffect, useState } from 'react';

import { Avatar } from './components/Avatar';
import { Menu } from './components/Menu';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../../components/presentational/tooltip/Tooltip';
import IconUser from '../../../icons/IconUser';
import { ConfigContext } from '../../contexts/ConfigContext';
import I18nContext from '../../contexts/I18nContext';
import LoginContext from '../../contexts/LoginContext';

interface UserMenuProps {
  readonly loggedInOverride?: boolean;
}

function UserMenu({ loggedInOverride }: UserMenuProps): JSX.Element {
  const { LOGIN_SIGN_IN_LINK } = useContext(ConfigContext);
  const { t } = useContext(I18nContext);
  const loginContext = useContext(LoginContext);
  const { userProfile, isLoggedIn, signIn, signOut } = loginContext;
  const [clientOnly, setClientOnly] = useState(false);

  useEffect(() => {
    setClientOnly(true);
  }, []);

  const signInButton = LOGIN_SIGN_IN_LINK ? (
    <a
      className="au-flex au-items-center au-text-c14 au-leading-c16 au-no-underline au-text-white "
      href={LOGIN_SIGN_IN_LINK}
    >
      {IconUser({ className: 'au-h-7 au-w-7 au-mr-1.5' })}
      <span className="au-hidden md:au-block">
        {clientOnly ? t('userMenu.signIn', { ns: 'common' }) : ''}
      </span>
    </a>
  ) : (
    <button
      className="au-flex au-items-center au-text-c14 au-leading-c16 au-no-underline au-text-white "
      onClick={signIn}
      type="button"
    >
      {IconUser({ className: 'au-h-7 au-w-7 au-mr-1.5' })}
      <span className="au-hidden md:au-block">
        {clientOnly ? t('userMenu.signIn', { ns: 'common' }) : ''}
      </span>
    </button>
  );

  const parsedLoggedIn =
    typeof loggedInOverride !== 'undefined' ? loggedInOverride : isLoggedIn;

  return (
    <div>
      {parsedLoggedIn && clientOnly ? (
        <Tooltip placement="bottom" trigger="click">
          <TooltipTrigger asChild>
            <Avatar
              pictureUrl={userProfile?.picture || ''}
              firstName={userProfile?.given_name || ''}
              lastName={userProfile?.family_name || ''}
            />
          </TooltipTrigger>
          <TooltipContent>
            <Menu
              userId={userProfile?.sub || ''}
              logoutOnClickOverride={signOut}
            />
          </TooltipContent>
        </Tooltip>
      ) : (
        signInButton
      )}
    </div>
  );
}

UserMenu.defaultProps = {
  loggedInOverride: undefined,
};

UserMenu.attributes = {
  loggedInOverride: {
    type: 'boolean',
    default: undefined,
  },
};

export default UserMenu;
